function parseCookies(cookieString) {
    if (cookieString) {
        const cookiesArray = cookieString.split(';');
        const cookiesObj = cookiesArray.reduce((acc, cookie)=>{
            const parts = cookie.split('=');
            const part = parts.shift();
            if (part) return {
                ...acc,
                [part.trim()]: decodeURI(parts.join('='))
            };
            return acc;
        }, {});
        return cookiesObj;
    }
    return {};
}
const utils_parseCookies = parseCookies;
export default utils_parseCookies;
export { parseCookies };
